import React, { useState, useEffect } from 'react';
import '../popup/popup.styles.css';
import sendEmail from '../cart/EmailSender'; // Adjust the import path as needed

const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};

const getCookie = (name: string) => {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
};

const Popup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [numberInput, setNumberInput] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const scrollHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const remainingHeight = scrollHeight - (scrollPosition + windowHeight);

    if (
      getCookie('popupSubmitted') !== 'true' &&
      remainingHeight <= scrollHeight / 2
    ) {
      setShowPopup(true);
      document.body.classList.add('scroll-lock');
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNumberInput(event.target.value);
    setError(''); // Clear error when user starts typing
  };

  const handleSubmit = async () => {
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(numberInput)) {
      setError('Please enter a valid 10-digit phone number.');
      return;
    }

    try {
      await sendEmail({
        name: 'Customer Number',
        number: numberInput,
        message: `Arun here – the user entered number: ${numberInput}\n\nGowtham, this is more than just a number – it's a potential client looking for something special. Reach out with confidence and turn this lead into something amazing! 🚀✨`,
      });

      setSubmitted(true);
      setShowPopup(false);
      document.body.classList.remove('scroll-lock');
      setCookie('popupSubmitted', 'true', 1 / 24);

      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    } catch (error) {
      console.error('Failed to send email:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleCancel = () => {
    setShowPopup(false);
    setSubmitted(false);
    setError('');
    document.body.classList.remove('scroll-lock');
  };

  useEffect(() => {
    if (getCookie('popupSubmitted') !== 'true') {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.classList.remove('scroll-lock');
    };
  }, []);

  return (
    <div>
      {showPopup && !submitted && (
        <div className="popup">
          <div className="popup-content col-10 col-md-8 col-lg-4">
            <img
              src="https://cdn0.weddingwire.in/article/9086/3_2/960/jpg/16809-creative-wedding-photography-avinash-dhoundhiyal-photography-lead-image.jpeg"
              alt="Header"
              className="w-100 object-fit-cover"
              style={{ height: '200px', objectFit: 'cover' }}
            />
            <h3 className="mt-3 text-center px-2 p-lg-0">𝐆𝐞𝐭 𝐏𝐞𝐫𝐬𝐨𝐧𝐚𝐥𝐢𝐳𝐞𝐝 𝐄𝐯𝐞𝐧𝐭 𝐏𝐥𝐚𝐧𝐧𝐢𝐧𝐠 𝐀𝐬𝐬𝐢𝐬𝐭𝐚𝐧𝐜𝐞</h3>
            <p className="text-center px-2 p-lg-0 message">We’ll reach out to you with personalized options to make your event extraordinary!</p>
            <input
              className="mt-sm-2 col-10 col-sm-6"
              type="number"
              placeholder="Enter your phone number..."
              value={numberInput}
              onChange={handleInputChange}
              onKeyDown={handleKeyPress}
              required
            />
            {error && <span className="text-danger h6 text-center mt-2">{error}</span>}
            <button className="mb-4" onClick={handleSubmit}>Submit</button>

            <span className="text-secondary notes pb-2 text-center px-2">
              <span className="font-bold text-dark">Note: </span>
              Please share your phone number to continue. Your experience matters to us. 💜
            </span>
          </div>
        </div>
      )}

      {submitted && (
        <div className="popup">
          <div className="popup-content thank-you col-10 col-md-4 p-sm-5 p-3 position-relative">
            <img 
              className="w-25 p-3" 
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Eo_circle_green_checkmark.svg/1200px-Eo_circle_green_checkmark.svg.png" 
              alt="Success Icon" 
            />
            <h3 className="text-center">𝐓𝐡𝐚𝐧𝐤 𝐘𝐨𝐮 𝐟𝐨𝐫 𝐒𝐮𝐛𝐦𝐢𝐭𝐭𝐢𝐧𝐠!</h3>
            <p className="text-center">We truly appreciate your interest. Our team will be in touch shortly with personalized suggestions to make your event exceptional.</p>
            <button 
              className="cancel-btn rounded-circle px-3"
              // onClick={handleCancel}
              style={{ position: 'absolute', top: '-10px', right: '-10px' }}>
              X
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Popup;
